"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@formily/react");
var shared_1 = require("@formily/shared");
var schema_1 = require("../shared/schema");
var context_1 = require("../shared/context");
var expression_1 = require("../shared/expression");
var computeSchemaState = function (draft, prevState) {
    var schema = new schema_1.Schema(draft.props);
    var prevSchema = new schema_1.Schema(prevState.props);
    var currentRequired = schema.getExtendsRequired();
    var prevRequired = prevSchema.getExtendsRequired();
    var currentRules = schema.getExtendsRules();
    var prevRules = prevSchema.getExtendsRules();
    var currentEditable = schema.getExtendsEditable();
    var prevEditable = prevSchema.getExtendsEditable();
    if (shared_1.isValid(currentRequired) && !shared_1.isEqual(currentRequired, prevRequired)) {
        draft.required = currentRequired;
    }
    if (shared_1.isValid(currentRules) && !shared_1.isEqual(currentRules, prevRules)) {
        draft.rules = currentRules;
    }
    if (shared_1.isValid(currentEditable) && !shared_1.isEqual(currentEditable, prevEditable)) {
        draft.selfEditable = currentEditable;
    }
};
exports.SchemaField = function (props) {
    var path = shared_1.FormPath.parse(props.path);
    var formSchema = react_1.useContext(context_1.FormSchemaContext);
    var fieldSchema = new schema_1.Schema(props.schema || formSchema.get(path));
    var formRegistry = react_1.useContext(context_1.FormComponentsContext);
    var expressionScope = react_1.useContext(context_1.FormExpressionScopeContext);
    var ErrorTipPathStr = path.toString();
    if (!fieldSchema) {
        throw new Error("Can not found schema node by " + ErrorTipPathStr + ".");
    }
    if (!formRegistry) {
        throw new Error("Can not found any form components.");
    }
    var schemaType = fieldSchema.type;
    var schemaComponent = fieldSchema.getExtendsComponent();
    var schemaRenderer = fieldSchema.getExtendsRenderer();
    var initialComponent = schemaComponent || schemaType;
    var renderField = function (addtionKey, reactKey) {
        return react_1.default.createElement(exports.SchemaField, { key: reactKey, path: path.concat(addtionKey) });
    };
    var getPropsFromInterceptor = function (stateProps) {
        var _a;
        var interceptorProps = {};
        if (shared_1.isFn(formRegistry.componentPropsInterceptor)) {
            interceptorProps = formRegistry.componentPropsInterceptor(props) || {};
        }
        return __assign(__assign({}, stateProps), (_a = {}, _a['x-component-props'] = __assign(__assign({}, (stateProps['x-component-props'] || {})), interceptorProps), _a));
    };
    var renderFieldDelegate = function (callback) {
        return (react_1.default.createElement(react_2.Field, { path: path, initialValue: expression_1.complieExpression(fieldSchema.default, expressionScope), props: expression_1.complieExpression(fieldSchema.getSelfProps(), expressionScope, function (key) { return key == 'x-linkages'; }), dataType: fieldSchema.type, triggerType: fieldSchema.getExtendsTriggerType(), editable: fieldSchema.getExtendsEditable(), visible: expression_1.complieExpression(fieldSchema.getExtendsVisible(), expressionScope), display: expression_1.complieExpression(fieldSchema.getExtendsDisplay(), expressionScope), required: expression_1.complieExpression(fieldSchema.getExtendsRequired(), expressionScope), rules: expression_1.complieExpression(fieldSchema.getExtendsRules(), expressionScope), computeState: computeSchemaState }, function (_a) {
            var state = _a.state, mutators = _a.mutators, form = _a.form;
            var stateProps = getPropsFromInterceptor(state.props);
            var props = __assign(__assign({}, state), { props: stateProps, schema: new schema_1.Schema(fieldSchema).merge(stateProps), form: form,
                mutators: mutators,
                renderField: renderField });
            return (react_1.default.createElement(context_1.SchemaFieldPropsContext.Provider, { value: props }, callback(props)));
        }));
    };
    var renderVirtualFieldDelegate = function (callback) {
        return (react_1.default.createElement(react_2.VirtualField, { path: path, visible: expression_1.complieExpression(fieldSchema.getExtendsVisible(), expressionScope), display: expression_1.complieExpression(fieldSchema.getExtendsDisplay(), expressionScope), props: expression_1.complieExpression(fieldSchema.getSelfProps(), expressionScope, function (key) { return key == 'x-linkages'; }) }, function (_a) {
            var state = _a.state, form = _a.form;
            var stateProps = getPropsFromInterceptor(state.props);
            var props = __assign(__assign({}, state), { props: stateProps, schema: new schema_1.Schema(fieldSchema).merge(stateProps), form: form,
                renderField: renderField, children: fieldSchema.mapProperties(function (schema, key) {
                    return (react_1.default.createElement(exports.SchemaField, { schema: schema, key: key, path: path.concat(key) }));
                }) });
            return (react_1.default.createElement(context_1.SchemaFieldPropsContext.Provider, { value: props }, callback(props)));
        }));
    };
    var renderProperties = function () {
        return fieldSchema.mapProperties(function (schema, key) {
            var childPath = path.concat(key);
            return (react_1.default.createElement(exports.SchemaField, { schema: schema, key: childPath.toString(), path: childPath }));
        });
    };
    if (fieldSchema.isObject() && !schemaComponent) {
        if (path.length == 0 || props.onlyRenderProperties) {
            return react_1.default.createElement(react_1.Fragment, null, renderProperties());
        }
        return renderFieldDelegate(function (props) {
            var renderComponent = function () {
                if (!formRegistry.formItemComponent) {
                    shared_1.log.error("Can not found any component.Its key is " + ErrorTipPathStr + ".");
                    return null;
                }
                return react_1.default.createElement(formRegistry.formItemComponent, props, renderProperties());
            };
            if (shared_1.isFn(schemaRenderer)) {
                return schemaRenderer(__assign(__assign({}, props), { renderComponent: renderComponent }));
            }
            return renderComponent();
        });
    }
    else {
        if (shared_1.isStr(initialComponent)) {
            if (formRegistry.fields[initialComponent]) {
                return renderFieldDelegate(function (props) {
                    var stateComponent = shared_1.lowercase(props.schema.getExtendsComponent() || props.schema.type);
                    if (!shared_1.isStr(stateComponent)) {
                        shared_1.log.error("Can not found any form component <" + stateComponent + ">.Its key is " + ErrorTipPathStr + ".");
                        return null;
                    }
                    var renderComponent = function () {
                        if (!formRegistry.fields[stateComponent]) {
                            shared_1.log.error("Can not found the field component <" + stateComponent + ">.Its key is " + ErrorTipPathStr + ".");
                            return null;
                        }
                        return react_1.default.createElement(formRegistry.formItemComponent, props, react_1.default.createElement(formRegistry.fields[stateComponent], props));
                    };
                    if (shared_1.isFn(schemaRenderer)) {
                        return schemaRenderer(__assign(__assign({}, props), { renderComponent: renderComponent }));
                    }
                    return renderComponent();
                });
            }
            else if (formRegistry.virtualFields[initialComponent]) {
                return renderVirtualFieldDelegate(function (props) {
                    var stateComponent = shared_1.lowercase(props.schema.getExtendsComponent() || props.schema.type);
                    if (!shared_1.isStr(stateComponent)) {
                        shared_1.log.error("Can not found any virtual form component <" + stateComponent + ">.Its key is " + ErrorTipPathStr + ".");
                        return null;
                    }
                    var renderComponent = function () {
                        if (!formRegistry.virtualFields[stateComponent]) {
                            shared_1.log.error("Can not found the virtual field component <" + stateComponent + ">.Its key is " + ErrorTipPathStr + ".");
                            return null;
                        }
                        return react_1.default.createElement(formRegistry.virtualFields[stateComponent], props);
                    };
                    if (shared_1.isFn(schemaRenderer)) {
                        return schemaRenderer(__assign(__assign({}, props), { renderComponent: renderComponent }));
                    }
                    return renderComponent();
                });
            }
            else {
                shared_1.log.error("Can not found the field component <" + initialComponent + ">.Its key is " + ErrorTipPathStr + ".");
                return null;
            }
        }
        else {
            shared_1.log.error("Can not found the field component <" + initialComponent + ">.Its key is " + ErrorTipPathStr + ".");
            return null;
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-schema-renderer/lib/components/SchemaField.js
// module id = 2080
// module chunks = 0